export default __webpack_public_path__ + "static/media/diamond.4204a279.png";